import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import get from 'lodash.get';

function DateFormatted(
    { date, type = 'DATE', el = 'span', defFormat = 'DD MM YY', inputFormat, theme, ...otherProps },
    { moment },
) {
    const tag = { el };
    const dateFormatted = moment(date, inputFormat).format(get(theme, `dateFormats.${type}`, defFormat));

    return (
        <tag.el title={type} {...otherProps}>
            {dateFormatted}
        </tag.el>
    );
}

DateFormatted.contextTypes = {
    moment: PropTypes.func,
};

DateFormatted.propTypes = {
    date: PropTypes.string.isRequired,
    type: PropTypes.string,
    el: PropTypes.string,
    defFormat: PropTypes.string,
    inputFormat: PropTypes.string,
    // From withTheme
    theme: PropTypes.object,
};

export default withTheme(DateFormatted);



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/DateFormatted.js
 **/